module.exports = __webpack_public_path__ + "static/media/017.747d22ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/017.jpg
// module id = 524
// module chunks = 0